import { Component, OnInit, inject, signal } from '@angular/core';
import { SHARED_DECLARATIONS } from '../../Common/shared.config';
import {
    ReactiveFormsModule,FormsModule,
    FormGroup, FormControl, FormArray,
    Validators,
    AbstractControl,
    AsyncValidatorFn,
    ValidationErrors,
} from '@angular/forms';
import { MATERIAL_MODULES } from '../../Common/material.config';  
import { ModalWindowBaseComponent } from '../../Common/modal-window/modal-window-base.component';
import { ModalWindowService, MAT_DIALOG_DATA, MatDialogRef } from '../../Common/modal-window/modal-window.service';
import { LoginService } from '../login.service';

@Component({
  selector: 'pwd-recover',
  templateUrl: './pwd-recover.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, ...MATERIAL_MODULES,
    FormsModule,
    ...SHARED_DECLARATIONS,
  ],
  styleUrls: [
      '../../Common/modal-window/modal-window.component.scss',
      './pwd-recover.component.scss'
  ]
})
export class PwdRecoverComponent extends ModalWindowBaseComponent implements OnInit {
  public override moda_window_ref: MatDialogRef<PwdRecoverComponent> = 
        inject(MatDialogRef<PwdRecoverComponent>);
  private _LoginS: LoginService = inject(LoginService);
  // private data: any = inject(MAT_DIALOG_DATA);
  
  public loading = signal<boolean>(false);
  public send_error = signal<boolean>(false);

  public mail_ctrl = new FormGroup({
      nombre: new FormControl('', [
        Validators.required,
      ]),
      // email: new FormControl('', [
      //     Validators.required,
      //     Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/),
      // ]),
  });
  private txt_error_message: string = '';

  private endpoint = 'send_recovery_password';
  // ===========================================================================
  ngOnInit(): void {

    this.send_error.set(false);
  
}
  // ---------------------------------------------------------------------------
  public sendRecoveryMail() {
      this.loading.set(true);
      this.send_error.set(false);
      console.log("Sending recovery mail to " + this.mail_ctrl.value.nombre);

      this._LoginS.sendPasswordRecoveryMail(this.mail_ctrl.value).subscribe({
        next: (response: any) => {
          console.log(response);
          if ( response.error.codigo === 0 || 
                response.error.codigo === '0' || 
                response.error.codigo === ''
          ) {
            this.mailSendedOK();
          } else {
            this.mailSendedKO(response.error.texto);
          }
        },
        error: (error: any) => {
          this.mailSendedKO("Error al enviar el correo: " + error.message);
        },
        complete: () => {
          this.loading.set(false);
        }
      });
  }

  // ---------------------------------------------------------------------------
  private mailSendedOK() {
      this.closeAndReturn(true);
  }
  // ---------------------------------------------------------------------------
  private mailSendedKO(mensaje: string) {
      this.txt_error_message = mensaje;
      this.send_error.set(true);
  }

  public error_message() {
    return this.txt_error_message;
  }

}
